import axios from '@/plugins/axios'

/**
 * Get specific product
 *
 * @param {*} slug
 * @returns
 */
const getProduct = async id => {
  try {
    const response = await axios.get(`products/${id}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get specific products
 *
 * @returns
 */
const getProducts = async ({
  type
}) => {
  try {
    const params = {
      type: type
    }
    const response = await axios.get('products', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getProduct,
  getProducts
}
